export default "__VITE_ASSET__sjaLaZ87__"